import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Loading from './Loading';

const ProtectedRoute = ({ children, roleRequired = null }) => {
    const { user, loading } = useAuth();

    console.log('🛡️ [ProtectedRoute] Checking access:');
    console.log('   Loading:', loading);
    console.log('   User:', user);
    console.log('   Role required:', roleRequired);
    console.log('   User role:', user?.role);

    if (loading) {
        console.log('⏳ [ProtectedRoute] Showing loading...');
        return <Loading />;
    }

    if (!user) {
        console.log('❌ [ProtectedRoute] No user, redirecting to login');
        return <Navigate to="/login" />;
    }

    // Verificar rol específico si se requiere (acepta string o array)
    const allowed = Array.isArray(roleRequired) ? roleRequired.includes(user.role) : (user.role === roleRequired);
    if (roleRequired && !allowed) {
        console.log(`🚫 [ProtectedRoute] Role mismatch. Required: ${JSON.stringify(roleRequired)}, User has: ${user.role}`);
        console.log('🔀 [ProtectedRoute] Redirecting to appropriate dashboard...');

        // Redirigir al dashboard apropiado según el rol del usuario
        if (user.role === 'admin') {
            console.log('➡️ [ProtectedRoute] Redirecting to /admin');
            return <Navigate to="/admin" />;
        }
        if (user.role === 'coordinator') {
            console.log('➡️ [ProtectedRoute] Redirecting to /coordinador');
            return <Navigate to="/coordinador" />;
        }
        if (user.role === 'technician') {
            console.log('➡️ [ProtectedRoute] Redirecting to /formulario');
            return <Navigate to="/formulario" />;
        }
        if (user.role === 'inspector') {
            console.log('➡️ [ProtectedRoute] Redirecting to /inspector');
            return <Navigate to="/inspector" />;
        }
        if (user.role === 'district_manager') {  // ← AGREGAR ESTO
            console.log('➡️ [ProtectedRoute] Redirecting to /gerente-distrito');
            return <Navigate to="/gerente-distrito" />;
        }

        console.log('⬅️ [ProtectedRoute] Unknown role, redirecting to login');
        return <Navigate to="/login" />;
    }

    console.log('✅ [ProtectedRoute] Access granted to', window.location.pathname);
    return children;
};

export default ProtectedRoute;